import { CommonModule } from '@angular/common'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { AngularMaterialsModules } from '../../module/materials.module'
import { AiAgentService } from '../../service/ai/ai-agent.service'
import { DdcLoggerService } from '../../service/log/ddc-logger.service'
import { ThemeService } from '../../service/theme/theme.service'
import { Themes } from '../../shared/enums/enums'
import { DdcAgentChatComponent } from './ddc-agent-chat/ddc-agent-chat.component'
import { DdcAgentContentComponent } from './ddc-agent-content/ddc-agent-content.component'
import { DdcAgentCourseComponent } from './ddc-agent-course/ddc-agent-course.component'
import { DdcAgentsListComponent } from './ddc-agents-list/ddc-agents-list.component'
import { Agent } from './models/agent.models'

@Component({
  selector: 'ddc-agents',
  templateUrl: './ddc-agents.component.html',
  styleUrls: ['./ddc-agents.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    AngularMaterialsModules,
    DdcAgentsListComponent,
    DdcAgentCourseComponent,
    DdcAgentContentComponent,
    DdcAgentChatComponent,
  ],
})
export class DdcAgentsComponent implements OnInit, OnDestroy {
  _agents: Agent[] = []
  _selectedAgent: Agent | null = null

  _theme: string = 'light-theme'
  _isLightTheme = true
  _isDarkTheme = false
  _isPaperTheme = false

  private subs = new Subscription()

  constructor(
    private logger: DdcLoggerService,
    public themeService: ThemeService,
    private agentService: AiAgentService,
  ) {
    this.subs.add(
      this.themeService.theme$.subscribe(theme => {
        this._theme = theme
        this._isLightTheme = theme === Themes.LIGHT
        this._isDarkTheme = theme === Themes.DARK
        this._isPaperTheme = theme === Themes.PAPER
      }),
    )
  }

  ngOnInit(): void {
    this.logger.info('DdcAgentsComponent ngOnInit()')

    this.subs.add(
      this.agentService.agents$.subscribe(agents => {
        this._agents = agents
        // Auto-select first agent if nothing selected
        if (!this._selectedAgent && agents.length > 0) {
          this.agentService.selectAgent(agents[0])
        }
      }),
    )

    this.subs.add(
      this.agentService.selectedAgent$.subscribe(agent => {
        this._selectedAgent = agent
      }),
    )

    this.agentService.connectWebSocket()
  }

  onAgentSelected(agent: Agent): void {
    this.agentService.selectAgent(agent)
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe()
  }
}
